import React from "react"
import Button from "../../../common/blocks/button/Button"
import Icon from "../../../common/blocks/icon/Icon"
import * as classNames from "./SearchField.module.scss"

function SearchField(props) {
  const addFiltredItems = (e) => {
    if (e.keyCode === 13) {
      props.setFiltredItems([...props.filtredItems, e.target.value])
      e.target.value = ""
      props.setName("")
      props.setFilteredSuggestionsItems([])
    }
  }
  const nameChangeHandler = (e) => {
    const userInput = e.currentTarget.value
    props.setName(userInput)
  }
  return (
    <div className={`${classNames.searchField} ${"form-control"}`}>
      <label
        htmlFor="JobSearch"
        className="sr-only"
      >
        Tags
      </label>
      <input
        type="search"
        name="JobSearch"
        id="JobSearch"
        placeholder="Commercial"
        autoComplete="on"
        onChange={nameChangeHandler}
        onKeyUp={addFiltredItems}
        // onClick={ () => (
        //     showSuggestion?setShowSuggestion(false):setShowSuggestion(true)
        //   )
        // }
      />
      <Button aspect="unstyled">
        <Icon
          icon="search"
          color="var(--gris)"
        />
      </Button>
    </div>
  )
}

export default SearchField
